import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapActions, mapGetters } from 'vuex';
import SettingFieldTable from '@/views/mixin/SettingFieldTable';
import MesTable from '@/api/MesTable/index.js';
import fastSearch from '@/components/fast-search';
import util from '@/libs/util';
import { ExportListData } from '@/api/SubDeliveryNote';
import store from '@/store/index';
import { assign } from 'xe-utils';
import ExportListMixin from '@/views/mixin/ExportList';
var mesTable = MesTable('SubDeliveryNote/LoadData'); // const mesTable = MesTable('ImsBillMst')

export default {
  mixins: [SettingFieldTable({
    defaultLoadDataApi: function defaultLoadDataApi(e) {
      return mesTable.LoadData(e);
    }
  }), ExportListMixin],
  components: {
    fastSearch: fastSearch
  },
  data: function data() {
    return {
      mainTable: [],
      code: '',
      formData: {
        Page: 1,
        // 当前页
        Limit: 10,
        // 分页大小
        LIST_ROUTE: store.getters.routerPath,
        Data: {
          VENDOR_CODE: util.getPARENT_VENDOR_CODE() ? util.getPARENT_VENDOR_CODE() : util.getVENDOR_CODE(),
          // VENDOR_CODE: util.getPARENT_VENDOR_CODE(),
          // VENDOR_CODE: "1.3.130",
          ORGANIZE_ID: util.cookies.get('ORG_ID')
        }
      },
      pageInfo: {
        TotalCount: 1,
        PageSize: 10,
        PageIndex: 1
      },
      loading: false
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // console.log('columnsWhere',this.columnsWhere);
              _this.code = _this.$route.query.code;
              _context.next = 3;
              return Promise.all([_this.getLoadData()]);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  mounted: function mounted() {
    var _this2 = this;

    this.Bus.on('onHandleBlackForShow', function () {
      _this2.$setOrderStatu('listShow');

      _this2.getLoadData();
    });
  },
  methods: {
    // ...mapActions('DeliveryNote/MaintainDeliveryNote2',['$setOrderStatu']),
    // 点击size
    handleSizeChange: function handleSizeChange(size) {
      this.formData.Limit = size;
      this.getLoadData();
    },
    // 点击页码
    handleCurrentChange: function handleCurrentChange(index) {
      this.formData.Page = index;
      this.getLoadData();
    },
    // 点击刷新
    handelRefresh: function handelRefresh() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var parmas, res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                parmas = {
                  Page: 1,
                  Limit: 10,
                  Data: {
                    ORGANIZE_ID: util.cookies.get('ORG_ID')
                  },
                  ParamList: []
                };
                _this3.loading = true;
                _context2.next = 4;
                return mesTable.LoadData(parmas);

              case 4:
                res = _context2.sent;
                _this3.loading = false;

                if (res.code === 0) {
                  // console.log('表格数据 res',res);
                  _this3.mainTable = res.data.Items.map(function (v) {
                    v.statusStyle = util.func.switchColor(v);
                    v.DELIVERY_DATE = util.formatTime.transCommDate(v.DELIVERY_DATE);
                    v.ARRIVAL_DATE = util.formatTime.transCommDate(v.ARRIVAL_DATE);
                    return v;
                  });
                  _this3.pageInfo.TotalCount = res.data.TotalCount;
                  _this3.pageInfo.PageSize = res.data.PageSize;
                  _this3.pageInfo.PageIndex = res.data.PageIndex;

                  _this3.$message.success('数据已刷新');
                }

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 点击导出
    handelExportListData: function handelExportListData() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // this.$openLoading()
                // const res = await ExportListData(this.formData)
                // this.$closeLoading()
                // if (res.code === 0) {
                //   window.open(this.$store.getters.getVUE_APP_DOWN + res.data)
                // } else {
                //   this.$message.warning('数据导出失败----' + res.message)
                // }
                _this4.formData.Data.EXPORT_FILE_NAME = '下游送货单列表';

                _this4.$message.success('已添加到 导出列表 中');

                _this4.setUnreadExportMessionNum();

                ExportListData(_this4.formData);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 点击送货单号
    handleDELIVERY_NO: function handleDELIVERY_NO(row) {
      console.log('点击送货单号 row', row); // console.log('mainTable',this.mainTable);

      this.$setOrderStatu('orderShow'); // console.log('index',index);

      this.$emit('onClickDELIVERY_NO', row); // this.$nextTick(function () {
      //     this.Bus.emit('onClickDELIVERY_NO',row,index,this.mainTable)
      // })
    },
    // 点击新增
    handelAddBtn: function handelAddBtn() {
      this.$setOrderStatu('addOrder');
    },
    TranslationSTATUS: function TranslationSTATUS(STATUS) {
      switch (STATUS) {
        case 1:
          return '未处理';
        // 未处理

        case 2:
          return '审核';
        // 审核

        case 3:
          return '作废';
        // 作废

        case 4:
          return '在途';
        // 在途

        case 5:
          return '收货';
        // 收货
      }
    },
    // 获取列表
    getLoadData: function getLoadData() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this5.loading = true;
                _this5.formData.Data.ORGANIZE_ID = util.cookies.get('ORG_ID');
                _context4.next = 4;
                return mesTable.LoadData(_this5.formData);

              case 4:
                res = _context4.sent;
                console.log('表格数据 res', res);
                _this5.loading = false;

                if (res.code === 0) {
                  _this5.mainTable = res.data.Items.map(function (v) {
                    v.statusStyle = util.func.switchColor(v);
                    v.DELIVERY_DATE = util.formatTime.transCommDate(v.DELIVERY_DATE);
                    v.ARRIVAL_DATE = util.formatTime.transCommDate(v.ARRIVAL_DATE);
                    return v;
                  });
                  _this5.pageInfo.TotalCount = res.data.TotalCount;
                  _this5.pageInfo.PageSize = res.data.PageSize;
                  _this5.pageInfo.PageIndex = res.data.PageIndex;
                } // console.log('this.mainTable',this.mainTable);
                // this.loading = false
                // this.mainTable = res.data
                // this.totalPage = res.TotalCount
                // this.clearDetail()


              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    // 搜索
    search: function search() {
      this.formData.Page = 1;
      this.getLoadData();
    },
    fastSearch: function fastSearch(searchData) {
      // console.log('searchData',searchData);
      // console.log('this.formData',this.formData);
      this.formData.ParamList = this.mergeParamList(searchData.ParamList, this.formData.ParamList); // let data = {}
      // searchData.ParamList.forEach(item => {
      //     let obj = {}
      //     obj[item.PARAM_NAME] = item.PARAM_VALUE
      //     assign(data,obj)
      // });
      // // console.log('data',data);
      // // assign(this.formData.Data,data)
      // data.ORGANIZE_ID = util.cookies.get('ORG_ID')
      // this.formData.Data = data
      // this.formData.Page = 1
      // console.log('this.formData',this.formData);

      this.getLoadData();
    }
  },
  watch: {
    $SubDeliveryNoteState: {
      handler: function handler(nawValue) {
        console.log('单据操作状态 MaintainDeliveryNote2OrderState==>', nawValue);

        if (nawValue === 'listShow') {
          // 订单列表
          this.getLoadData();
        }
      },
      immediate: true
    }
  },
  computed: {},
  beforeDestroy: function beforeDestroy() {
    this.Bus.off('onHandleBlackForShow');
    this.Bus.off('onHandelExportListData');
  }
};